import NitroButton from '../parts/NitroButton';

const Error = ({message, nextStep}) => {

  const errorMsg = message?message:'An error occured with this question type';

  return (
    <>
      <div className="grow py-12">
        <div className="container max-w-lg">
          <p>{errorMsg}</p>
        </div>
      </div>
      <NitroButton label="Next" formIsValid={true} onClick={nextStep} />
    </>
  );
}

export default Error;
